import { h } from 'preact'; /** @jsx h */
import { useEffect } from 'preact/hooks';

import simpleParallax from 'simple-parallax-js';

import './Hero.scss';

const Hero = ({ imageSrc, alt, children }) => {
    // useEffect for simpleParallax on full width images
    useEffect(() => {
        const heroImage = document.querySelector('.hero-image');

        // eslint-disable-next-line new-cap
        const heroParallax = new simpleParallax(heroImage, {
            orientation: 'down',
            overflow: true
        });

        return () => {
            if (heroImage) {
                heroParallax.destroy();
            }
        };
    }, []);

    return (
        <section className="hero">
            <img className="hero-image" decoding="async" loading="lazy" src={imageSrc} alt={alt} />
            <div className="hero-content">{children}</div>
        </section>
    );
};

export default Hero;
